import io from 'socket.io-client'

let socket

const BROWSER = !process || ( process && process.browser ),
	ELECTRON_MAIN = process && process.type === 'browser',
	ELECTRON_RENDERER = !BROWSER && !process.type,
	IS_DEV = process.env.NODE_ENV !== 'production'

console.log( process, 'process.type', process.type, 'BROWSER', BROWSER, 'ELECTRON_MAIN', ELECTRON_MAIN, 'ELECTRON_RENDERER', ELECTRON_RENDERER )

if( BROWSER ){
	const socketOpts = { secure: true }
	console.log( window, window.location, window.hostname )
	if( ['localhost', 'localhost.rphaven.com'].includes( window.location.hostname ) ){
		console.log( 'socket.io connecting to //localhost.rphaven.com:8443' )
		socket = io.connect( '//localhost.rphaven.com:8443', socketOpts )
	} else if( window.location.pathname === '/chattest.html' || window.location.host === 'testchat.rphaven.com' ){
		console.log( 'socket.io connecting to //chatsocket.rphaven.com:8443' )
		socket = io.connect( '//chatsocket.rphaven.com:8443', socketOpts )
	} else { // window.location.pathname === '/' default
		console.log( 'socket.io connecting to //chatsocket.rphaven.com:443' )
		socket = io.connect( '//chatsocket.rphaven.com:443', {
			secure: true,
			reconnectionDelay: 3000,
			reconnectionDelayMax: 90000
		})
	}
} else if( ELECTRON_MAIN ){
	/*( async() => {
		const electron = await import( 'electron' ),
			ipcMain = electron.ipcMain,
			socketOpts = { secure: true, autoConnect: false },
			replyDict = {}

		if( IS_DEV ){
			socket = io.connect( 'http://localhost.rphaven.com:8443', socketOpts )
		} else {
			socket = io.connect( 'https://chatsocket.rphaven.com:443', socketOpts )
		}

		ipcMain.on( 'socketOperationConnect', ( e ) => {
			socket.connect()
		})
		ipcMain.on( 'socketOperationOn', ( e, eventName, fn ) => {
			if( !replyDict[eventName] || !replyDict[eventName].includes( e.processId ) ){
				replyDict[eventName] = [...new Set( [...( replyDict[eventName] || [] ), e.processId] )] //add unique id to list for eventName
				socket.on( eventName, ( data ) => {
					e.reply( 'socketReplyOn', eventName, data )
				})
			}
			//console.log( 'replyDict', eventName, replyDict[eventName] )
		})
		ipcMain.on( 'socketOperationEmit', ( e, eventName, data ) => {
			socket.emit( eventName, data )
		})
		ipcMain.on( 'socketOperationEmitAck', ( e, callbackId, eventName, data ) => {
			socket.emit( eventName, data, ( returnedData ) => {
				e.reply( 'socketReplyEmitAck', callbackId, returnedData )
			})
		})

		/*const _onevent = socket.onevent
		socket.onevent = ( packet, ...rest ) => {
			console.log( 'onevent packet', packet, 'arguments', rest )
			_onevent.call( socket, packet )
		}*//*
	})()*/
} else if( ELECTRON_RENDERER ){
	const onListeners = {},
		onceListeners = {},
		callbacks = new Map()
	let callbackId = 0

	socket = {
		emit: ( eventName, ...data ) => {
			if( typeof data[data.length - 1] === 'function' ){
				callbackId += 1
				callbacks.set( callbackId, data[data.length - 1] )
				window.ipc.send( 'socketOperationEmitAck', callbackId, eventName, ...data.slice( 0, -1 ) )
			} else {
				window.ipc.send( 'socketOperationEmit', eventName, ...data )
			}
		},
		on: ( eventName, fn ) => { //fn doesn't get sent over ipc. Call on response
			window.ipc.send( 'socketOperationOn', eventName )
			onListeners[eventName] = [...( onListeners[eventName] || [] ), fn]
		},
		once: ( eventName, fn ) => {
			window.ipc.send( 'socketOperationOn', eventName )
			onceListeners[eventName] = [...( onceListeners[eventName] || [] ), fn]
		}
	}

	window.ipc.on( 'socketReplyEmitAck', ( e, id, data ) => {
		const callback = callbacks.get( id )
		callback( data )
		callbacks.delete( id )
	})

	window.ipc.on( 'socketReplyOn', ( e, eventName, data ) => {
		onListeners[eventName] && onListeners[eventName].forEach( ( fn ) => {
			fn( data )
		})
		if( onceListeners[eventName] ){
			onceListeners[eventName] = onceListeners[eventName].filter( ( fn ) => {
				fn( data )
				return false
			})
		}
	})
}

export default socket